import React from 'react';
import Cards from 'react-credit-cards-2';
import 'react-credit-cards-2/dist/es/styles-compiled.css';
import { CardNumber } from './components/CardNumber';
import { CardMonthYear } from './components/CardMonthYear';
import { CardCvc } from './components/CardCvc';
import { isMobileScreen } from '@apply/ui';
import {
    useCustomPaymentCardFocus,
    useCustomPaymentCardMonthYear,
    useCustomPaymentCardNumber,
    useCustomPaymentCVC,
    useCustomPaymentName,
} from '../../../../fields/CustomPaymentFields';

export interface CardInfo {
    expiry: string;
    cvc: string;
    number: string;
    cardType: undefined | 'VISA' | 'MASTERCARD';
}

export interface CardPaymentProps {
    customPaymentId: string;
    disabled: boolean;
}

export const CardPayment: React.FC<CardPaymentProps> = ({ customPaymentId, disabled }) => {
    const mobileScreen = isMobileScreen();
    const [name] = useCustomPaymentName(customPaymentId);
    const [cardMonthYear] = useCustomPaymentCardMonthYear(customPaymentId);
    const [cvc] = useCustomPaymentCVC(customPaymentId);
    const [cardNumber] = useCustomPaymentCardNumber(customPaymentId);
    const [cardFocus] = useCustomPaymentCardFocus(customPaymentId);

    const getColumnSize = (numberOfColumns: number, resizeForMobile: boolean) => {
        switch (numberOfColumns) {
            case 3:
                return resizeForMobile && mobileScreen ? '100%' : '32%';
            case 2:
                return resizeForMobile && mobileScreen ? '100%' : '49%';
            case 1:
                return '100%';
            default:
                return '100%';
        }
    };

    return (
        <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between' }}>
            <div style={{ width: getColumnSize(2, true), display: 'flex', flexWrap: 'wrap', alignContent: 'center' }}>
                <Cards
                    name={name ?? ''}
                    cvc={cvc ?? ''}
                    expiry={cardMonthYear ?? ''}
                    number={cardNumber ?? ''}
                    focused={cardFocus}
                />
            </div>
            <div style={{ width: getColumnSize(2, true) }}>
                <CardNumber
                    customPaymentId={customPaymentId}
                    disabled={disabled}
                />
                <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between' }}>
                    <div style={{ width: getColumnSize(2, false), display: 'flex', flexWrap: 'wrap', alignContent: 'center' }}>
                        <CardMonthYear
                            customPaymentId={customPaymentId}
                            disabled={disabled}
                        />
                    </div>
                    <div style={{ width: getColumnSize(2, false), display: 'flex', flexWrap: 'wrap', alignContent: 'center' }}>
                        <CardCvc
                            customPaymentId={customPaymentId}
                            disabled={disabled}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};
